var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2560.000000pt",
    height: "2560.000000pt",
    viewBox: "0 0 2560.000000 2560.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2560.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 12780 l0 -12750 12750 0 12750 0 0 12750 0 12750 -12750 0 -12750 0 0 -12750z m23918 3 l2 -11163 -11165 0 -11165 0 0 11165 0 11165 11163 -2 11162 -3 3 -11162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16857 21039 c-33 -52 -3547 -6129 -3547 -6134 0 -3 1604 -5 3565 -5 1961 0 3565 2 3565 5 0 8 -3542 6129 -3555 6144 -11 11 -15 9 -28 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6985 15192 l-1781 -3077 1783 -3 c981 -1 2586 -1 3568 0 l1784 3 -1779 3075 c-979 1691 -1783 3076 -1787 3077 -5 2 -809 -1382 -1788 -3075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15092 10352 c-980 -1694 -1782 -3082 -1782 -3086 0 -3 1604 -6 3565 -6 1961 0 3565 3 3565 6 0 7 -3548 6144 -3560 6157 -3 4 -808 -1378 -1788 -3071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8726 10564 c-25 -44 -828 -1431 -1785 -3084 l-1738 -3005 3565 -3 c1961 -1 3567 -1 3569 1 2 2 -787 1369 -1753 3038 -966 1669 -1769 3056 -1784 3083 l-28 49 -46 -79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract);
export default __webpack_public_path__ + "static/media/Abstract.4bd0eda7960e7f09ed1b9f04b294ce56.svg";
export { ForwardRef as ReactComponent };